import AnimatedBackground from '../components/AnimatedBackground';
import { Reveal } from '../components/Motion';
import { COMPANY } from '../data/site';

function Field({ label, value }) {
  return (
    <div className="border-b border-white/10 py-4 grid grid-cols-1 md:grid-cols-[220px_1fr] gap-2 md:gap-8 items-baseline">
      <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-white/50">{label}</div>
      <div className="text-white/85">{value}</div>
    </div>
  );
}

export default function Mentions() {
  const tbc = <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-white/40">À compléter</span>;
  return (
    <section className="relative pt-24 md:pt-32 pb-24 overflow-hidden">
      <AnimatedBackground />
      <div className="relative z-10 max-w-[1100px] mx-auto px-5 md:px-10">
        <Reveal>
          <div className="overline mb-4">◍ Mentions légales</div>
          <h1 className="font-display italic text-6xl md:text-7xl leading-[0.95]">Mentions légales.</h1>
        </Reveal>

        <div className="mt-14 space-y-14">
          <div>
            <h2 className="font-display italic text-3xl mb-6">Éditeur du site</h2>
            <Field label="Raison sociale" value={COMPANY.name} />
            <Field label="Forme juridique" value={tbc} />
            <Field label="SIREN" value={tbc} />
            <Field label="SIRET" value={tbc} />
            <Field label="Numéro de TVA" value={tbc} />
            <Field label="Responsable de publication" value={tbc} />
            <Field label="Adresse" value={`${COMPANY.address}, ${COMPANY.city}`} />
            <Field label="Téléphone" value={COMPANY.phone} />
            <Field label="E-mail" value={COMPANY.email} />
          </div>
          <div>
            <h2 className="font-display italic text-3xl mb-6">Hébergeur</h2>
            <Field label="Hébergeur" value={tbc} />
            <Field label="Adresse de l’hébergeur" value={tbc} />
          </div>
          <div>
            <h2 className="font-display italic text-3xl mb-6">Propriété intellectuelle</h2>
            <p className="text-white/70 leading-relaxed max-w-3xl">
              L’ensemble des contenus présents sur ce site (textes, images, graphismes, marque, logo)
              sont la propriété exclusive de {COMPANY.name} ou de ses partenaires. Toute reproduction,
              représentation ou diffusion, totale ou partielle, est interdite sans autorisation
              préalable écrite.
            </p>
          </div>
          <div>
            <h2 className="font-display italic text-3xl mb-6">Limitation de responsabilité</h2>
            <p className="text-white/70 leading-relaxed max-w-3xl">
              {COMPANY.name} met tout en œuvre pour proposer des informations à jour et exactes.
              La société ne saurait toutefois être tenue responsable des erreurs, omissions ou
              indisponibilités du site. L’utilisateur reconnaît utiliser ces informations sous sa
              propre responsabilité.
            </p>
          </div>
          <div>
            <h2 className="font-display italic text-3xl mb-6">Droit applicable</h2>
            <p className="text-white/70 leading-relaxed max-w-3xl">
              Le présent site et ses mentions légales sont soumis au droit français. Tout litige
              relatif à leur interprétation ou à leur exécution relève de la compétence exclusive
              des tribunaux français.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
